import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { PUBLIC_BASE } from './config';
import PublicLayout from '../../components/public/PublicLayout';

export default function PublicReviewPaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const orderId = searchParams.get('orderId') || '';
    const paymentKey = searchParams.get('paymentKey') || '';
    const amountStr = searchParams.get('amount') || '';
    const amount = Number(amountStr);

    if (!orderId || !paymentKey || !amountStr || Number.isNaN(amount)) {
      setErrorMsg('결제 파라미터가 올바르지 않습니다.');
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const savedForm = sessionStorage.getItem('publicReviewApplyPayload');
        if (!savedForm) {
          throw new Error('신청 정보가 유실되었습니다. 다시 시도해 주세요.');
        }
        const formData = JSON.parse(savedForm);

        await axios.post('/api/public/reviewApply/payment/confirm', {
          orderId, paymentKey, amount,
          ...formData,
        });

        sessionStorage.removeItem('publicReviewApplyPayload');
        alert('결제가 정상적으로 완료되었습니다.');
        navigate(`${PUBLIC_BASE}/review`);
      } catch (error) {
        console.error('결제 에러:', error);
        setErrorMsg(
          error?.response?.data?.errorMessage ||
          error?.response?.data?.message ||
          error.message ||
          '결제 확인 중 오류가 발생했습니다.'
        );
      } finally {
        setLoading(false);
      }
    })();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <PublicLayout>
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-sky-500 mr-3" />
          <span className="text-sm text-slate-500">결제 확인 중...</span>
        </div>
      </PublicLayout>
    );
  }

  if (errorMsg) {
    return (
      <PublicLayout>
        <div className="flex flex-col justify-center items-center h-64 gap-3">
          <div className="text-red-500 font-bold">결제 확인 실패</div>
          <div className="text-slate-400 text-sm">{errorMsg}</div>
          <button className="px-4 py-2 rounded-xl bg-sky-600 text-white hover:bg-sky-500 transition-colors"
            onClick={() => navigate(`${PUBLIC_BASE}/review`)}>
            목록으로
          </button>
        </div>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <div className="flex justify-center items-center h-64">
        <span className="text-slate-400">결제 확인 완료</span>
      </div>
    </PublicLayout>
  );
}
